export const socialMedia = [
  { img: 'bale.svg', link: 'https://ble.ir/witro' },
  { img: 'aparat.svg', link: 'https://www.aparat.com/Witro.Shop' },
  {
    img: 'youtube.svg',
    link: 'https://www.youtube.com/channel/UCyq-kdyPSiNRsgyyOX1yIQw',
  },
  {
    img: 'linkedin-box-fill.svg',
    link: 'https://www.linkedin.com/company/naqshava',
  },
  { img: 'instagram-fill.svg', link: 'https://instagram.com/witro.shop' },
];

export const downloadLinks = {
  bazaar: 'https://cafebazaar.ir/app/app.witro.shop',
};
